//natives
import React, { Component } from "react";
import Cookies from "universal-cookie";
import Checkbox from "@material-ui/core/Checkbox";
import { Helmet } from "react-helmet";
// import TagManager from 'react-gtm-module';

//components
import Alerta from "../../../../../util/snackbars/.mixins/";

// controllers
import OpcoesRecebimentoGrupoFornecedor from "../../../../../../controllers/opcoesRecebimentoGrupoFornecedor";
import Config from "../../../../../../controllers/config";
import Log from "../../../../../../controllers/log";

//childrens
import Columns from "../childrens/columns/.mixins";
import UsuariosLista from "../childrens/usuariosLista/.mixins";

export default class ConfGrupoFornecedor_ae extends Component {
    constructor(props) {
        super(props);

        this.child = React.createRef();

        this.state = {
            itensTable: [],
            title: "Adicionar fornecedor ao grupo",
            columns: [],
            isLoading: true,
            isError: false,
            error: null,
        };

        //binds
        this.setState = this.setState.bind(this);
        this.loadData = this.loadData.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.setState({
            columns: Columns(this),
        });
        //carregamento de dados nos campos
        this.loadData(this);
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:conf-grupo-fornecedor',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-conf-grupo-fornecedor',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get("User-Token");
        Log.info(
            token,
            "Efetuado carregamento da tela configuração grupo fornecedores opções recebimento!"
        );
    }

    renderAtivo = ({ value, codigo }) => {
        return (
            <div align="center">
                <Checkbox
                    edge="start"
                    value={codigo}
                    checked={value}
                    tabIndex={-1}
                    disableRipple
                    onClick={() => {
                        this.handlerCheck(codigo);
                    }}
                />
            </div>
        );
    };
    check(valor) {
        var itens = this.state.itensTable;
        var check = true;
        itens.forEach((element) => {
            if (element.ID_PESSOA == valor) {
                check = element.ativo.value;
                element.ativo.value = !element.ativo.value;
            }
        });
        this.setState({
            itensTable: itens,
            columns: Columns(this),
        });
        const retorno = {
            valor: valor,
            check: check,
        };
        return retorno;
    }

    handlerCheck(valor) {
        const retorno = this.check(valor);
        this.addUsuario(this, retorno.valor, retorno.check);
    }

    async addUsuario(props, id, check) {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");

        try {
            const body = {
                id_org: this.props.params.id,
                id_pessoa: id,
                in_ativar: check ? "N" : "S",
            };

            const params = JSON.stringify(body);
            const o_pessoa = await OpcoesRecebimentoGrupoFornecedor.PostFornecedoresGrupo(
                token,
                params
            );
            const json = JSON.parse(o_pessoa.body);
            if (props.child.current != null) {
                if (o_pessoa.res.statusCode == 200) {
                    if (check) {
                        props.child.current.retorno("Removido associação com sucesso!", "success");
                    } else {
                        props.child.current.retorno(json.message, "success");
                    }

                    // TagManager.dataLayer({
                    //     dataLayer: {
                    //       event: 'event',
                    //       eventCategory: 'tokstok:fornecedores:conf-grupo-fornecedor',
                    //       eventAction: 'callback',
                    //       eventLabel: `sucesso:${json.message}`,
                    //     }
                    // });
                } else if (o_pessoa.res.statusCode == 300) {
                    props.child.current.retorno(json.message, "warning");
                    this.check(id);
                } else {
                    throw new Error("Campos necessários não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            if (props.child.current != null) {
                props.child.current.retorno("Erro ao carregar dados!", "error");
            }
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE") {
                errorString = error.message;
            }
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString,
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:conf-grupo-fornecedor',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    }

    async loadData(props) {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");
        const filters = {
            idOrg: this.props.params.id,
        };

        try {
            const o_pessoa = await OpcoesRecebimentoGrupoFornecedor.getAllFornecedoresGrupo(
                token,
                filters
            );
            const j_pessoa = JSON.parse(o_pessoa.body);

            const arrayItens = j_pessoa.map((e) => {
                return {
                    ...e,
                    ativo: {
                        codigo: e.ID_PESSOA,
                        value: e.IN_ATIVO_ORG.includes("S"),
                    },
                };
            });

            if (o_pessoa.res.statusCode == 200) {
                props.setState({
                    itensTable: arrayItens,
                    isLoading: false,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:conf-grupo-fornecedor',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:lista-fornecedores-grupos`,
                //     }
                // });
            } else {
                if (
                    j_pessoa.status == false &&
                    j_pessoa.message &&
                    j_pessoa.message.includes("Token inválido!") &&
                    props.child.current != null
                ) {
                    props.child.current.retorno("Autentificação inválida!", "error");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            if (props.child.current != null) {
                props.child.current.retorno("Erro ao carregar dados!", "error");
            }
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE") {
                errorString = error.message;
            }
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString,
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:conf-grupo-fornecedor',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Usuários`}</title>
                </Helmet>
                <UsuariosLista {...this} />
                <Alerta ref={this.child} />
            </div>
        );
    }
}
